<su-ui-module-overview-configuration-form
  [seahorseModule]="seahorseModule"
  [configuration]="configuration"
></su-ui-module-overview-configuration-form>

<sh-dialog-footer>
  <sh-button
    label="shared.terms.cancel"
    variant="text"
    (click)="dialogRef.cancel()"
  ></sh-button>
  <sh-button
    label="shared.terms.save"
    [disabled]="!isValid || saveStarted"
    [loading]="saveStarted"
    (click)="save()"
  ></sh-button>
</sh-dialog-footer>
